// ファイル名: category-carousel.js
// カテゴリーカルーセルのインタラクション制御

class CategoryCarousel {
  constructor(element) {
    this.carousel = element;
    this.track = element.querySelector('[data-carousel-track]');
    this.list = element.querySelector('[data-carousel-list]');
    this.prevButton = element.querySelector('[data-carousel-prev]');
    this.nextButton = element.querySelector('[data-carousel-next]');
    this.items = this.list.querySelectorAll('.category-carousel__item');
    
    // 設定値の取得
    this.itemsPerView = this.getItemsPerView();
    this.currentIndex = 0;
    
    // イベントリスナーの設定
    this.init();
  }
  
  init() {
    // ボタンのクリックイベント
    this.prevButton?.addEventListener('click', () => this.slidePrev());
    this.nextButton?.addEventListener('click', () => this.slideNext());
    
    // リサイズイベント
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.itemsPerView = this.getItemsPerView();
        this.updateCarousel();
      }, 250);
    });
    
    // 初期状態の設定
    this.updateCarousel();
  }
  
  getItemsPerView() {
    const width = window.innerWidth;
    if (width < 768) {
      return parseInt(this.carousel.closest('section').dataset.itemsPerViewMobile || 4);
    }
    return parseInt(this.carousel.closest('section').dataset.itemsPerViewDesktop || 6);
  }
  
  slidePrev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateCarousel();
    }
  }
  
  slideNext() {
    const maxIndex = Math.max(0, this.items.length - this.itemsPerView);
    if (this.currentIndex < maxIndex) {
      this.currentIndex++;
      this.updateCarousel();
    }
  }
  
  updateCarousel() {
    // スライド位置の更新
    const itemWidth = this.items[0]?.offsetWidth || 0;
    const gap = parseFloat(getComputedStyle(this.list).gap) || 16;
    const offset = this.currentIndex * (itemWidth + gap);
    
    this.list.style.transform = `translateX(-${offset}px)`;
    
    // ボタンの有効/無効状態を更新
    this.updateButtons();
  }
  
  updateButtons() {
    const maxIndex = Math.max(0, this.items.length - this.itemsPerView);
    
    // 前へボタン
    if (this.prevButton) {
      this.prevButton.disabled = this.currentIndex === 0;
      this.prevButton.setAttribute('aria-disabled', this.currentIndex === 0);
    }
    
    // 次へボタン
    if (this.nextButton) {
      this.nextButton.disabled = this.currentIndex >= maxIndex;
      this.nextButton.setAttribute('aria-disabled', this.currentIndex >= maxIndex);
    }
  }
}

// DOMContentLoadedで初期化
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.category-carousel');
  carousels.forEach(carousel => {
    // データ属性の設定
    const section = carousel.closest('section');
    const sectionData = section.querySelector('script[type="application/json"]');
    if (sectionData) {
      const settings = JSON.parse(sectionData.textContent);
      section.dataset.itemsPerViewDesktop = settings.items_per_view_desktop;
      section.dataset.itemsPerViewMobile = settings.items_per_view_mobile;
    }
    
    new CategoryCarousel(carousel);
  });
});

// Shopify Theme Editorでのセクション再読み込み対応
document.addEventListener('shopify:section:load', (event) => {
  const carousel = event.target.querySelector('.category-carousel');
  if (carousel) {
    new CategoryCarousel(carousel);
  }
});
